module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "currency",
      rawName: "v-currency"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.required && !_vm.field.hide
      }),
      expression: "{required: required && !field.hide}"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name,
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "name": _vm.field.name,
      "readonly": _vm.locked
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-105f65a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/CurrencyRender.vue
// module id = 1558
// module chunks = 1